namespace RioERP.Reports {
    export interface GstReportSummaryWithGstinForm {
        ESourceType: Serenity.EnumEditor;
        FranchiseeId: Serenity.LookupEditor;
        Name: Serenity.StringEditor;
        OrderMonth: Serenity.EnumEditor;
        OrderYear: Serenity.EnumEditor;
        TotalTaxableAmount: Serenity.DecimalEditor;
        TotalTaxAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class GstReportSummaryWithGstinForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.GstReportSummaryWithGstin';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GstReportSummaryWithGstinForm.init)  {
                GstReportSummaryWithGstinForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(GstReportSummaryWithGstinForm, [
                    'ESourceType', w0,
                    'FranchiseeId', w1,
                    'Name', w2,
                    'OrderMonth', w0,
                    'OrderYear', w0,
                    'TotalTaxableAmount', w3,
                    'TotalTaxAmount', w3,
                    'CgstAmount', w3,
                    'SgstAmount', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3
                ]);
            }
        }
    }
}
